module.exports = __webpack_public_path__ + "static/media/Logo_Oakwood_Sign_In.83781520.svg";